import { render } from "./Ad.vue?vue&type=template&id=3b9270c8&scoped=true"
import script from "./Ad.vue?vue&type=script&lang=js"
export * from "./Ad.vue?vue&type=script&lang=js"

import "./Ad.vue?vue&type=style&index=0&id=3b9270c8&scoped=true&lang=css"

import exportComponent from "/data0/www.sxsmdx.cn/src/ui/src-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9270c8"]])

export default __exports__